module.exports = __webpack_public_path__ + "static/img/background.efed6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/background.png
// module id = hZlF
// module chunks = 89